import React, { FC } from 'react';
import { Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useTranslation } from 'react-i18next';
import HelpArticleView from '../help-center/help-article-view.component';

type AssistantArticlePanelProps = {
    articleId: string;
    /** Beside the chat (wide drawer) or on top of it (narrow drawer). */
    isBesideChat: boolean;
    onArticleChange: (articleId: string) => void;
    onClose: () => void;
};

/** DD-3780: a help article opened from the chat. Closing it returns to the same conversation. */
const AssistantArticlePanel: FC<AssistantArticlePanelProps> = ({
    articleId,
    isBesideChat,
    onArticleChange,
    onClose,
}: AssistantArticlePanelProps) => {
    const { t: translate } = useTranslation(['common', 'help-drawer']);
    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            sx={isBesideChat ? { borderLeft: 1, borderColor: 'divider', pl: 2 } : undefined}
        >
            <Box display="flex" justifyContent={isBesideChat ? 'flex-end' : 'flex-start'} mb={1}>
                {isBesideChat ? (
                    <Button variant="text" startIcon={<CloseIcon />} onClick={onClose}>
                        {translate('common:CLOSE')}
                    </Button>
                ) : (
                    <Button variant="text" startIcon={<ArrowBackIosIcon />} onClick={onClose}>
                        {translate('help-drawer:BACK_TO_CHAT')}
                    </Button>
                )}
            </Box>
            <Box flexGrow={1} sx={{ overflowY: 'auto' }}>
                <HelpArticleView articleId={articleId} onLinkClick={onArticleChange} />
            </Box>
        </Box>
    );
};

export default AssistantArticlePanel;
